import { NgModule } from '@angular/core';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorPopUpComponent } from './Components/ErrorPopUp/ErrorPopUpComponent';
import { PopUpBusyComponent } from './Components/ErrorPopUp/PopUpBusyComponent';
import { BaseService } from './Services/BaseService';
import { AppHelpInfoService } from './Services/Custom/ServiceAppHelpInfo';
import { CalendarService } from './Services/Custom/ServiceCalendar';
import { CalendarEventService } from './Services/Custom/ServiceCalendarEvent';
import { ChecklistService } from './Services/Custom/ServiceChecklist';
import { ChecklistTaskService } from './Services/Custom/ServiceChecklistTask';
import { CommendationService } from './Services/Custom/ServiceCommendation';
import { CompanyService } from './Services/Custom/ServiceCompany';
import { CompanyAnnouncementService } from './Services/Custom/ServiceCompanyAnnouncement';
import { CompanyCourseService } from './Services/Custom/ServiceCompanyCourse';
import { CompanyTypeTrackerService } from './Services/Custom/ServiceCompanyTypeTracker';
import { CourseService } from './Services/Custom/ServiceCourse';
import { CourseAssignmentService } from './Services/Custom/ServiceCourseAssignment';
import { CourseAssignmentLessonService } from './Services/Custom/ServiceCourseAssignmentLesson';
import { CourseFeedbackService } from './Services/Custom/ServiceCourseFeedback';
import { CourseLessonService } from './Services/Custom/ServiceCourseLesson';
import { DepartmentService } from './Services/Custom/ServiceDepartment';
import { DocumentService } from './Services/Custom/ServiceDocument';
import { DocumentAssignmentService } from './Services/Custom/ServiceDocumentAssignment';
import { DocumentHistoryService } from './Services/Custom/ServiceDocumentHistory';
import { EmploymentService } from './Services/Custom/ServiceEmployment';
import { InvoiceService } from './Services/Custom/ServiceInvoice';
import { JobDescriptionService } from './Services/Custom/ServiceJobDescription';
import { JobDesignationService } from './Services/Custom/ServiceJobDesignation';
import { JobHistoryService } from './Services/Custom/ServiceJobHistory';
import { LeaveRequestService } from './Services/Custom/ServiceLeaveRequest';
import { LeaveRequestApprovalService } from './Services/Custom/ServiceLeaveRequestApproval';
import { MenuFavoriteService } from './Services/Custom/ServiceMenuFavorite';
import { MoneyService } from './Services/Custom/ServiceMoney';
import { OfficeService } from './Services/Custom/ServiceOffice';
import { PaymentService } from './Services/Custom/ServicePayment';
import { PerformanceReviewService } from './Services/Custom/ServicePerformanceReview';
import { PerformanceReviewQuestionService } from './Services/Custom/ServicePerformanceReviewQuestion';
import { PersonService } from './Services/Custom/ServicePerson';
import { PersonLoginService } from './Services/Custom/ServicePersonLogin';
import { PersonOfficeService } from './Services/Custom/ServicePersonOffice';
import { PersonRoleService } from './Services/Custom/ServicePersonRole';
import { PhoneService } from './Services/Custom/ServicePhone';
import { PTOActualService } from './Services/Custom/ServicePTOActual';
import { PTOEntitlementService } from './Services/Custom/ServicePTOEntitlement';
import { PTOTemplateService } from './Services/Custom/ServicePTOTemplate';
import { PTOTemplateAssignmentService } from './Services/Custom/ServicePTOTemplateAssignment';
import { SalaryHistoryService } from './Services/Custom/ServiceSalaryHistory';
import { SearchService } from './Services/Custom/ServiceSearch';
import { StatsService } from './Services/Custom/ServiceStats';
import { TimeZoneService } from './Services/Custom/ServiceTimeZone';
import { ToDoService } from './Services/Custom/ServiceToDo';
import { TrackerDocService } from './Services/Custom/ServiceTrackerDoc';
import { TypeCalendarEventService } from './Services/Custom/ServiceTypeCalendarEvent';
import { TypeCompanyDiscountService } from './Services/Custom/ServiceTypeCompanyDiscount';
import { TypeCountryService } from './Services/Custom/ServiceTypeCountry';
import { TypeCourseCatagoryService } from './Services/Custom/ServiceTypeCourseCatagory';
import { TypeCourseTagService } from './Services/Custom/ServiceTypeCourseTag';
import { TypeEmploymentService } from './Services/Custom/ServiceTypeEmployment';
import { TypeGenderService } from './Services/Custom/ServiceTypeGender';
import { TypeMaritalStatusService } from './Services/Custom/ServiceTypeMaritalStatus';
import { TypePaymentSubscriptionService } from './Services/Custom/ServiceTypePaymentSubscription';
import { TypePersonRoleService } from './Services/Custom/ServiceTypePersonRole';
import { TypePhoneService } from './Services/Custom/ServiceTypePhone';
import { TypeSalaryService } from './Services/Custom/ServiceTypeSalary';
import { TypeSalaryChangeService } from './Services/Custom/ServiceTypeSalaryChange';
import { TypeSourceOfHireService } from './Services/Custom/ServiceTypeSourceOfHire';
import { TypeStateService } from './Services/Custom/ServiceTypeState';
import { TypeSubscriptionCategoryService } from './Services/Custom/ServiceTypeSubscriptionCategory';
import { TypeTerminationService } from './Services/Custom/ServiceTypeTermination';
import { TypeTrackerService } from './Services/Custom/ServiceTypeTracker';
import { DialogService } from './Services/DialogService';
import { UrlService } from './Services/UrlService';
import { ConfirmComponent } from './Components/ErrorPopUp/ConfirmComponent';

@NgModule({
	declarations: [
		ErrorPopUpComponent,
		PopUpBusyComponent,
		ConfirmComponent
	],
	providers: [
		UrlService,
		BaseService,
		DialogService,
	
		HttpClient,
		LeaveRequestService,
		LeaveRequestApprovalService,
		TypeCountryService,
		TypeStateService,
		TypePhoneService,
		TypeGenderService,
		TypePersonRoleService,
		JobHistoryService,
		TypeSalaryService,
		TypeSalaryChangeService,
		TypeEmploymentService,
		SalaryHistoryService,
		TypeMaritalStatusService,
		TypeSourceOfHireService,
		TypeTerminationService,
		PersonService,
		DocumentHistoryService,
		TypePaymentSubscriptionService,
		DocumentAssignmentService,
		CompanyService,
		PerformanceReviewService,
		CommendationService,
		PTOTemplateService,
		OfficeService,
		PTOActualService,
		PTOEntitlementService,
		PersonOfficeService,
		CompanyAnnouncementService,
		PhoneService,
		PTOTemplateAssignmentService,
		PersonRoleService,
		InvoiceService,
		ChecklistService,
		EmploymentService,
		ChecklistTaskService,
		TypeCalendarEventService,
		PersonLoginService,
		DepartmentService,
		JobDesignationService,
		CalendarService,
		CalendarEventService,
		TimeZoneService,
		PerformanceReviewQuestionService,
		JobDescriptionService,
		ToDoService,
		CourseService,
		CompanyCourseService,
		CourseAssignmentService,
		PaymentService,
		CourseAssignmentLessonService,
		DocumentService,
		CourseLessonService,
		TypeCourseCatagoryService,
		TypeCourseTagService,
		TypeSubscriptionCategoryService,
		MoneyService,
		SearchService,
		StatsService,
		CourseFeedbackService,
		TypeCompanyDiscountService,
		MenuFavoriteService,
		TypeTrackerService,
		TrackerDocService,
		CompanyTypeTrackerService,
		AppHelpInfoService
	]
})
export class ServiceModule { }
